import React, { useEffect } from "react";
import "./Homepage.css";
import Background from "../../hero-pattern.svg";
import BillDetail from "../../bill-detail.svg";
import { AspectRatio, Box, Button, Stack, Typography } from "@mui/joy";
import HowTo from "./HowTo";
import Stats from "./Stats";
import FrequentlyAskedQuestions from "./FrequentlyAskedQuestions";

function Homepage() {
  useEffect(() => {
    document.title = 'Civic Engage';
  }, []);

  const goToBills = (event) => {
    event.preventDefault();
    window.history.pushState({}, "", "/bills")

    // communicate to Routes that URL has changed
    const navEvent = new PopStateEvent('popstate');
    window.dispatchEvent(navEvent);
  };

  const goToLegislators = (event) => {
    event.preventDefault();
    window.history.pushState({}, "", "/legislators")

    // communicate to Routes that URL has changed
    const navEvent = new PopStateEvent('popstate');
    window.dispatchEvent(navEvent);
  };
  
  const goToResources = (event) => {
    event.preventDefault();
    window.history.pushState({}, "", "/resources")

    // communicate to Routes that URL has changed
    const navEvent = new PopStateEvent('popstate');
    window.dispatchEvent(navEvent);
  };
  return (
    <Stack
      className="hero-image"
      direction={"column"}
      sx={{
        alignItems: 'center',
        backgroundImage: "url(" + Background + ")"
      }}
    >
      <Stack direction={"column"} spacing={4} padding={8}>
        <Stack direction={"column"} spacing={1}>
          <Typography
            level="h1"
            style={{ textAlign: "center" }}
            sx={{
              fontSize: { sm: "40px", md: "64px" },
            }}
          >
            Welcome to Civic Engage
          </Typography>
          <Typography level="body-lg" style={{ textAlign: "center" }}>
            Learn how to understand and act on legislation by contacting your
            representatives through an easy to use email template.
          </Typography>
        </Stack>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="solid"
            color="primary"
            onClick={(e) => goToLegislators(e)}
          >
            Find Your Representative
          </Button>
          <Button variant="soft" color="neutral" onClick={(e) => goToBills(e)}>
            Explore Legislation
          </Button>
        </Stack>
        <AspectRatio
          ratio="1135 / 450"
          objectFit="contain"
          flex={true}
          color="transparent"
          sx={{
            overflow: "hidden",
            flexBasis: { sm: "auto", md: 300 },
          }}
        >
          <img alt="" src={BillDetail} />
        </AspectRatio>
      </Stack>
      <Stack direction={'column'} sx={{maxWidth:'1280px'}}>
        <HowTo />
        <Stats />
        <FrequentlyAskedQuestions goToResources={goToResources} />
      </Stack>
    </Stack>
  );
}

export default Homepage;
